import { FC } from 'react';
import { ZoneTag } from 'src/components/ui/ZoneTag';
import { PolygonsFilterType } from 'src/config/types';
import { useAppSelector } from 'src/hooks/useRedux';

interface ContoursFunctionsFilterProps {
  handleSelect: (id: number, filterName: keyof PolygonsFilterType) => void;
  tempFilter: PolygonsFilterType;
}

export const ContoursFunctionsFilter: FC<ContoursFunctionsFilterProps> = ({
  handleSelect,
  tempFilter,
}) => {
  const { contours } = useAppSelector(state => state.categories);

  return (
    <div className="flex flex-wrap gap-2">
      {contours.map(func => (
        <ZoneTag
          key={`contours-func-${func.id}`}
          isActive={tempFilter?.contours?.includes(func.id)}
          fullWidth
          onClick={() => handleSelect(func.id, 'contours')}
          category={{ ...func }}
        />
      ))}
    </div>
  );
};
